module.exports = __webpack_public_path__ + "static/media/logo.848bdf32.svg";